<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Arsa"
    }
</script>

<style scoped>

</style>